import { List, Row, Descriptions } from "antd";
import Pix from "../../../../../../Models/Financeiro/Titulo/Pagamento/Pix";

interface IPixListItemProps extends React.ComponentProps<typeof Descriptions> {
    data:Pix
}

export default function PixListItem({
    data,
    ...props
}:IPixListItemProps) {
    return <Descriptions {...props}>
        <Descriptions.Item label="Forma">{data.tipo?.nome}</Descriptions.Item>
        <Descriptions.Item label="Conta">{data.conta?.nome ?? data.codConta}</Descriptions.Item>
        <Descriptions.Item label="Identificador Banco">{data.identificadorProvedor}</Descriptions.Item>
        {data.identificadorProvedorCancelamento && <Descriptions.Item label="Identificador Banco (Cancelamento)">{data.identificadorProvedorCancelamento}</Descriptions.Item>}
    </Descriptions>;
}